import { style } from '@vanilla-extract/css';

export const platformsContainer = style({
  position: 'relative',
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'var(--justify-content)',
  gap: 'var(--buttons-gap)',
  padding: 'var(--padding)',
  width: 'var(--width)',

  '@media': {
    'only screen and (--mobile)': {
      justifyContent: 'var(--mobile-justify-content)',
    },
  },
});

export const platformButton = style({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  padding: 'var(--button-padding)',
  backgroundColor: 'var(--button-background)',
  borderRadius: 'var(--button-border-radius)',
  borderWidth: 'var(--button-border-width)',
  borderColor: 'var(--button-border-color)',
  borderStyle: 'var(--button-border-style)',
  textDecoration: 'none',
  cursor: 'pointer',
  transition: 'opacity 0.2s ease',

  ':hover': {
    opacity: 0.8,
  },
});

export const platformIcon = style({
  width: 'var(--icon-size)',
  height: 'var(--icon-size)',
  flexShrink: 0,
  borderRadius: '4px',
  overflow: 'hidden',
});

export const platformLabel = style({
  whiteSpace: 'nowrap',
  fontSize: 'var(--label-font-size)',
  fontWeight: 'var(--label-font-weight)',
  fontFamily: 'var(--label-font-family)',
  color: 'var(--label-color)',
  lineHeight: '1.25',
});

export const heading = style({
  fontSize: 'var(--heading-font-size)',
  fontWeight: 'var(--heading-font-weight)',
  color: 'var(--heading-color)',
  lineHeight: 'normal',
});
